import React from 'react';

import SimpleField from './simple';

export default function TextAreaDealField(props) {
  return <SimpleField {...props} inputClassName="resize-v" type="textarea" />;
}
